/*  ========================================================================
    # Scripts - InView
    ========================================================================  */

const InView = {
  cfg: {
    inViewElements: document.querySelectorAll('[data-observe]')
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.inViewElements.forEach(element => {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      });

      observer.observe(element);
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.inViewElements.length > 0) this.handler();
  }
};

export default InView;
